import styled from '@emotion/styled'

export const StyledTable = styled.table`
  font-size: 13px;
  background: white;
  border-collapse: separate;
  border-radius: 4px;
  border-spacing: 0px;
  min-width: 821px;
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid #d4d8dd;

  &:last-child {
    margin-bottom: 0;
  }

  thead {
    th {
      border-right: 1px solid #d4d8dd;

      &:last-of-type {
        border-right: none;
      }
    }

    tr:first-of-type {
      th {
        border-bottom: 1px solid #d4d8dd;
      }

      th:first-of-type {
        border-radius: 4px 0 0 0;
        -moz-border-radius: 4px 0 0 0;
        -webkit-border-radius: 4px 0 0 0;
      }

      th:last-of-type {
        border-radius: 0 4px 0 0;
        -moz-border-radius: 0 4px 0 0;
        -webkit-border-radius: 0 4px 0 0;
      }
    }

    tr:last-of-type {
      th {
        border-bottom: 1px solid #d4d8dd;
        border-right: 1px solid #d4d8dd;
      }
    }

    th {
      &.header-level-0 {
        padding: 5px;
        text-align: center;
        background-color: #e9f1fc;
        width: 460px;
      }
    }
  }

  tbody tr {
    th {
      border-right: 1px solid #d4d8dd;
    }

    &:last-child {
      th:first-of-type {
        border-radius: 0 0 0 4px;
        -moz-border-radius: 0 0 0 4px;
        -webkit-border-radius: 0 0 0 4px;
      }

      td:last-child {
        border-radius: 0 0 4px 0;
        -moz-border-radius: 0 0 4px 0;
        -webkit-border-radius: 0 0 4px 0;
      }
    }
  }

  .section-name,
  .category-header {
    text-align: center;
    background: #f7f7f7;
  }

  .category-header {
    padding: 5px;
    border-bottom: 1px solid #d4d8dd;
  }

  .section-name {
    padding: 5px 0px;
    width: 110px;
  }

  .view-table-cell,
  .input-field {
    min-width: 130px;
    max-width: 130px;
    padding: 3px 10px;
    border-right: none;
  }

  .section-name {
    + .input-field + .input-field,
    + .view-table-cell + .view-table-cell,
    + td[colspan] {
      border-right: 1px solid #d4d8dd;
    }

    + .category-header + .category-header {
      border-right: 1px solid #d4d8dd;
    }

    &:last-of-type {
      + .input-field + .input-field,
      + .view-table-cell + .view-table-cell,
      + td[colspan],
      + .category-header + .category-header {
        border-right: none;
      }
    }
  }

  .input-field {
    .ant-select {
      min-width: 130px;
      max-width: 130px;
    }

    + .input-field {
      border-left: initial;
    }
  }
`

export const TableTitle = styled.h4`
  font-size: 13px;
  margin-bottom: 0;
  color: #7c8291;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, calc(452px / 3)) 152px;
  grid-template-rows: auto auto;
  gap: 0;
  text-align: center;
  border: 1px solid #d4d8dd;
  border-radius: 4px;

  .grid-header {
    background: #e9f1fc;
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #d4d8dd;

    &:first-of-type {
      border-top-left-radius: 4px;
    }
  }

  button {
    text-align: left;
  }
`

export const DebitHeader = styled.div`
  grid-column: 1 / 4;
  border-right: 1px solid #d4d8dd;
`

export const CreditHeader = styled.div`
  grid-column: 4 / 7;
`

export const SummaryHeader = styled.div`
  grid-column: 7 / 8;
  grid-row: 1 / 2;

  &.grid-header {
    border-right: none;
    border-left: 1px solid #d4d8dd;
    border-top-right-radius: 4px;
  }
`

export const GridItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 100%;
  }

  &.section-name {
    background: #f7f7f7;
    border-right: 1px solid #d4d8dd;
    border-bottom: 1px solid #d4d8dd;

    min-height: 30px;

    &.last-section {
      border-bottom: none;
    }

    &.account-item,
    &.account-sub-item {
      border-right: none;
    }

    &.bblr-4 {
      border-bottom-left-radius: 4px;
    }
  }

  &.value {
    padding: 5px 10px;
  }

  &.border-right {
    border-right: 1px solid #d4d8dd;
  }
`
